import { render, staticRenderFns } from "./RinvL.vue?vue&type=template&id=121c4e4c"
import script from "./RinvL.vue?vue&type=script&lang=js"
export * from "./RinvL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports